import { Box, Typography, Card, Tooltip } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { hasLlpEvent, hasNonLlpEvent } from '../utils';
import { numberWithCommas, roundAmount } from '../../../utils';

const flattenSummary = (summary) => (Array.isArray(summary) ? summary : []).flatMap((entry) => Object.entries(entry || {}));

const BreakdownTooltip = ({ splitSummary, nonLlpSummary }) => {
  const splitRows = flattenSummary(splitSummary);
  const nonLlpRows = flattenSummary(nonLlpSummary);
  if (splitRows.length === 0 && nonLlpRows.length === 0) return "No breakup available";
  return (
    <Box sx={{ p: 0.5, minWidth: 160 }}>
      {splitRows.length > 0 ? (
        <Box sx={{ mb: nonLlpRows.length > 0 ? 1 : 0 }}>
          {splitRows.map(([label, amount]) => (
            <Box key={label} sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
              <Typography variant="caption" sx={{ color: "inherit" }}>{label}</Typography>
              <Typography variant="caption" sx={{ color: "inherit", fontWeight: 600 }}>US${numberWithCommas(roundAmount(amount))}</Typography>
            </Box>
          ))}
        </Box>
      ) : null}
      {nonLlpRows.length > 0 ? (
        <Box>
          <Typography variant="caption" sx={{ color: "inherit", fontWeight: 600, display: "block", mb: 0.25 }}>Non LLP</Typography>
          {nonLlpRows.map(([label, amount]) => (
            <Box key={label} sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
              <Typography variant="caption" sx={{ color: "inherit" }}>{label}</Typography>
              <Typography variant="caption" sx={{ color: "inherit", fontWeight: 600 }}>US${numberWithCommas(roundAmount(amount))}</Typography>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

 const FundBalanceCard = ({  shopVisit, claimInfo })=> {
  const isLlpEvent = hasLlpEvent(shopVisit);
  const isPrsv = shopVisit?.asset_type === 2 ? hasNonLlpEvent(shopVisit) : shopVisit?.prsv;
  return (
        <Card className="shop-visit-fund-balance-card" >
          {shopVisit?.fund_balance?.is_engine === true ? (
            <Box display="flex" flexDirection="column" gap={0.5}>
              {/* <Typography variant="body2">Balance</Typography> */}
              <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                {!isPrsv && !isLlpEvent ? (
                  <>
                    <Box flex="1" minWidth="100px">
                      <Typography variant="caption" display="block"> PRSV </Typography>
                      <Typography variant="caption" sx={{ marginTop: "-2px" }}> -- </Typography>
                    </Box>
                    <Box flex="1" minWidth="100px">
                      <Typography variant="caption" display="block"> LLP Replacement </Typography>
                      <Typography variant="caption"> -- </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    {isPrsv ? <Box flex="1" minWidth="100px">
                      <Typography variant="caption" display="block"> PRSV </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, marginTop: "-2px" }}>
                        <Typography variant="caption"> US${((shopVisit?.fund_balance?.prsv?.prsv_total || 0) + (shopVisit?.fund_balance?.prsv?.non_llp_total || 0))?.toLocaleString() || "0.00"} </Typography>
                        {(shopVisit?.fund_balance?.prsv?.split_summary?.length > 0 || shopVisit?.fund_balance?.prsv?.non_llp_summary?.length > 0) ? (
                          <Tooltip title={<BreakdownTooltip splitSummary={shopVisit?.fund_balance?.prsv?.split_summary} nonLlpSummary={shopVisit?.fund_balance?.prsv?.non_llp_summary} />} arrow placement="bottom-start">
                            <InfoOutlinedIcon sx={{ fontSize: 14, cursor: "pointer", color: "#fff" }} />
                          </Tooltip>
                        ) : null}
                      </Box>
                    </Box> : null}
                    {isLlpEvent ? <Box flex="1" minWidth="100px">
                      <Typography variant="caption" display="block"> LLP Replacement </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Typography variant="caption"> US${((shopVisit?.fund_balance?.llp?.llp_total || 0) + (shopVisit?.fund_balance?.llp?.non_llp_total || 0))?.toLocaleString() || "0.00"} </Typography>
                        {(shopVisit?.fund_balance?.llp?.split_summary?.length > 0 || shopVisit?.fund_balance?.llp?.non_llp_summary?.length > 0) ? (
                          <Tooltip title={<BreakdownTooltip splitSummary={shopVisit?.fund_balance?.llp?.split_summary} nonLlpSummary={shopVisit?.fund_balance?.llp?.non_llp_summary} />} arrow placement="bottom-start">
                            <InfoOutlinedIcon sx={{ fontSize: 14, cursor: "pointer", color: "#fff" }} />
                          </Tooltip>
                        ) : null}
                      </Box>
                    </Box> : null}
                  </>
                )}
              </Box>
            </Box>
          ) : (
            <Box>
              {/* <Typography variant="body2">Balance</Typography> */}
              {shopVisit?.fund_balance ? <Typography variant="caption"> US${shopVisit?.fund_balance?.overall_total?.toLocaleString() || "0.00"} </Typography> :  <Typography variant="caption"> N/A </Typography>  }
            </Box>
          )}
        </Card>
  );
}
export default FundBalanceCard


